import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

/**
 * Card primitives. The visual style is owned by `styles/briefer.css`:
 *   Card        → `.section` (dark navy card with the Lopettia palette)
 *   CardHeader  → `.section-head`
 *   CardTitle   → `h2` inside the section title block
 *   CardContent → `.section-body` (vertical-stack form rows)
 *
 * Pages that want the numbered eyebrow ("01.") + label ("Discovery · Phase
 * One") should render <IntakeSection> instead. This primitive keeps the
 * dark-card look for the simpler cases (admin pages, modals).
 */
export const Card = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <section ref={ref} className={cn('section active', className)} {...props} />
  ),
)
Card.displayName = 'Card'

export const CardHeader = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div ref={ref} className={cn('section-head', className)} {...props} />
  ),
)
CardHeader.displayName = 'CardHeader'

export const CardTitle = forwardRef<HTMLHeadingElement, HTMLAttributes<HTMLHeadingElement>>(
  ({ className, ...props }, ref) => (
    <div className="section-title-block">
      <h2 ref={ref} className={className} {...props} />
    </div>
  ),
)
CardTitle.displayName = 'CardTitle'

export const CardContent = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => <div ref={ref} className={cn('section-body', className)} {...props} />,
)
CardContent.displayName = 'CardContent'
